import { render, staticRenderFns } from "./Trajectory.vue?vue&type=template&id=05510c46&scoped=true&"
import script from "./Trajectory.vue?vue&type=script&lang=js&"
export * from "./Trajectory.vue?vue&type=script&lang=js&"
import style0 from "./Trajectory.vue?vue&type=style&index=0&id=05510c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05510c46",
  null
  
)

export default component.exports